export default __webpack_public_path__ + "static/luke@2x-8a957c19c62f53c180b070899ad400c7.jpg";